export default __webpack_public_path__ + "static/AleksandraPenkowska-1d605e920b61b916bceacde721169b8f.png";